export default __webpack_public_path__ + "static/image-section-pizza-c2100f883eb36db16b7e84d99cfa4255.webp";